angular.module('callX').controller('ManagePromoNumbersCtrl', ['$scope', '$state' ,'UserService','toaster','DateService','ManageNumbersService','CampaignsService', function($scope, $state, UserService,toaster,DateService,ManageNumbersService,CampaignsService) {

    $scope.currentUserData = UserService.getCurrentUserData();
    $scope.addPromoNumberCampaign = {};
    $scope.campaignFilterStatus = {status:'approved'};
    $scope.tableContentLoading = false;
    $scope.promoNumbersPendingList =[];
    $scope.promoNumbersList =[];
    $scope.showNoDataDiv = false;
    
    $scope.orderParam = 'phone_number';
    $scope.pubChanged = false;
    $scope.reverse = true;
    $scope.order = function(orderParam) {
        $scope.reverse = ($scope.orderParam === orderParam) ? !$scope.reverse : false;
        $scope.orderParam = orderParam;
    };

    var fetchAllPromoNumbers = function(){
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                $scope.tableContentLoading = false;
                $scope.promoNumbersList = data.data;
                if($scope.promoNumbersList.length == 0){
                    $scope.showNoDataDivAll = true;
                }else{
                    $scope.showNoDataDivAll = false;
                }
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        ManageNumbersService.getAllPromoNumbers(callbacks);
    };

    fetchAllPromoNumbers();

    var fetchPendingPromoNumbers = function(){
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                $scope.tableContentLoading = false;
                $scope.promoNumbersPendingList = data.data;
                if($scope.promoNumbersPendingList.length == 0){
                    $scope.showNoDataDivPending = true;
                }else{
                    $scope.showNoDataDivPending = false;
                }
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        ManageNumbersService.getPendingPromoNumbers(callbacks);
    };

    fetchPendingPromoNumbers();

    var fetchCampaignsList = function(){
        var callbacks = {
            success: function(data) {
                $scope.campaignsList = data.data;
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        ManageNumbersService.getCampaignsList(callbacks);
    };

    fetchCampaignsList();

    $scope.formReset = function(){
        $scope.promoNumberDescription = null;
        $scope.showAddPromoForm = 0;
    };

   $scope.addPromoNumber = function(){
        if ($scope.promoNumberDescription == undefined || $scope.promoNumberDescription == "") {
            toaster.pop('error', 'Error',  'Promo Number Description is required.', 2000);
        }else if ($scope.addPromoNumberCampaign.selected == undefined) {
            toaster.pop('error', 'Error',  'Please select a publisher.', 2000);
        }

       else {
            $scope.addingPromoNumber = true;
            var callbacks = {
                success: function (data) {
//                    console.log("Data",data);
                    $scope.showAddPromoForm = 0;
                    $scope.addingPromoNumber = false;
                    toaster.pop('success', 'Success', 'Promo Number Added', 2000);
                    fetchAllPromoNumbers();
                    fetchPendingPromoNumbers();
                    $scope.promoNumberDescription = '';
                },
                failure: function (data) {
                    $scope.showAddPromoForm = 0;
                    toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                    $scope.addingPromoNumber = false;
                    $scope.promoNumberDescription = '';
                }
            };
            ManageNumbersService.addPromoNumberWithDescription($scope.addPromoNumberCampaign.selected.campaign_id, {'description': $scope.promoNumberDescription,'promo_number_type':'inbound','user_id': $scope.currentUserData.id}, callbacks);
        }
    };

    $scope.savePromoNumber = function(index, promoId, description){
        if (description == undefined) {
            toaster.pop('error', 'Error',  'Promo Number Description is required.', 2000);
        }

        else {
            $scope.promoNumbersList[index].isSavingDescription = true;
            var callbacks = {
                success: function (data) {
//                    console.log("Data",data);
                    $scope.promoNumbersList[index].editContainer = false;
                    toaster.pop('success', 'Success', 'Promo Number updated', 2000);
                    fetchAllPromoNumbers();
                    fetchPendingPromoNumbers();
                },
                failure: function (data) {
                    $scope.promoNumbersList[index].editContainer = false;
                    toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                }
            };
            ManageNumbersService.savePromoNumber(promoId, {'description': description,'promo_number_type':'inbound'}, callbacks);
        }
    };

    $scope.deletePromoNumber = function(index, promoId){
        var callbacks = {
            success: function (data) {
                $scope.promoNumbersList[index].deleteContainer = false;
                toaster.pop('success', 'Success', 'Promo number successfully deleted', 2000);
                fetchAllPromoNumbers();
            },
            failure: function (data) {
                $scope.promoNumbersList[index].deleteContainer = false;
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
        ManageNumbersService.removePromoNumber(promoId, callbacks);
    };

    $scope.keepPromoNumberSaveAll = function(index, promoId, description){
//            console.log(index, promoId, description,"variables")
            var callbacks = {
                success: function (data) {
                    $scope.promoNumbersList[index].keepPromoNumber = false;
                    toaster.pop('success', 'Success', 'Promo number reclaimed successfully', 2000);
                    fetchPendingPromoNumbers();
                    fetchAllPromoNumbers();
                },
                failure: function (data) {
                    $scope.promoNumbersList[index].keepPromoNumber = false;
                    toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                }
            };
            ManageNumbersService.keepPromoNumber(promoId, {'description': description,'promo_number_type':'inbound','promo_number_status':'active'}, callbacks);
    };

    $scope.keepPromoNumberSavePending = function(index, promoId, description){
//            console.log(index, promoId, description,"variables")
            var callbacks = {
                success: function (data) {
                    $scope.promoNumbersPendingList[index].keepPromoNumber = false;
                    toaster.pop('success', 'Success', 'Promo number reclaimed successfully', 2000);
                    fetchPendingPromoNumbers();
                    fetchAllPromoNumbers();
                },
                failure: function (data) {
                    $scope.promoNumbersPendingList[index].keepPromoNumber = false;
                    toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                }
            };
            ManageNumbersService.keepPromoNumber(promoId, {'description': description,'promo_number_type':'inbound','promo_number_status':'active'}, callbacks);
    };

}]);